import React from "react";
import { useField } from "formik";
import { FormFeedback, FormGroup, Input } from "reactstrap";
// import { FormattedMessage } from 'react-intl';
const CardInput = (props) => {
    const [field, meta] = useField(props.name);
    return (
        <FormGroup className={`input-wrapper ${props?.className}`}>
            {props.label && <><label htmlFor={props?.id} >
                <span className={props.isRequired && 'required'}>{props.label}</span>
            </label></>}
            <div className="card-no d-flex">
                <Input
                    {...field}
                    {...props}
                    //   className={`${props?.inputClass}`}
                    autoComplete="off"
                />
                {props?.cardtype && <span className='icon d-inline-flex align-items-center justify-content-center'>
                    <img className='img-fluid' src={props?.cardtype} alt='Visa' />
                </span>}
            </div>
            {meta.touched && meta.error && (
                <FormFeedback className="d-block"> {meta?.error}
                    {/* <FormattedMessage id={meta.error} values={{
            name: props?.placeholder || 'This'
          }} /> */}
                </FormFeedback>
            )}
        </FormGroup>
    );
};
export default CardInput;